module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModal) ? _c('app-modal', {
    staticClass: "newsletter-modal center-block",
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "row col-xs-12 text-left"
  }, [_c('p', {
    staticClass: "pb-3",
    staticStyle: {
      "font-size": "30px",
      "font-weight": "700",
      "color": "#333333"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('NEWSLETTER_AGREEMENT')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('NEWSLETTER_AGREEMENT_INFO')))]), _vm._v(" "), _c('div', {
    staticClass: "text-center pt-2"
  }, [_c('span', {
    staticClass: "-button-grey buttons-container__button",
    staticStyle: {
      "cursor": "pointer",
      "color": "#706C69"
    },
    on: {
      "click": _vm.declineNewsletter
    }
  }, [_vm._v(_vm._s(_vm.$t('NO_I_DO_NOT_CONSENT')))]), _vm._v(" "), _c('span', {
    staticClass: "-button-red -small-button buttons-container__button mt-3",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.signUpNewsletter
    }
  }, [_vm._v(_vm._s(_vm.$t('YES_I_CONSENT')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "grants-section"
  }, [_c('div', {
    staticClass: "row row-flex"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 col-md-2"
  }, [(_vm.lang === 'pl') ? _c('img', {
    staticClass: "grants-img",
    attrs: {
      "src": require("../../../assets/images/footer-logo-pl.png")
    }
  }) : _c('img', {
    staticClass: "grants-img",
    attrs: {
      "src": require("../../../assets/images/footer-logo-en.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grants-content col-xs-12 col-sm-6 col-md-8"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('FOOTER_UE'))), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('FOOTER_UE_1')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 col-md-2"
  }, [(_vm.lang === 'pl') ? _c('img', {
    staticClass: "grants-img footer-img",
    attrs: {
      "src": require("../../../assets/images/footer-logo-ig-pl.png")
    }
  }) : _c('img', {
    staticClass: "grants-img footer-img",
    attrs: {
      "src": require("../../../assets/images/footer-logo-ig-en.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-footer__wrapper",
    staticStyle: {
      "direction": "ltr !important"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "max-width": "1220px"
    }
  }, [_c('div', {
    staticClass: "black-bar__bottom"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('p', {
    staticClass: "-small-paragraph -white-text"
  }, [_vm._v("Copyright 2019 Braster S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "-small-paragraph -white-text"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_SYSTEM')
    }
  }, [_vm._v(_vm._s(_vm.$t('SYSTEM')))])]), _vm._v(" "), _c('p', {
    staticClass: "-small-paragraph -white-text"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TERMS')
    }
  }, [_vm._v(_vm._s(_vm.$t('TERMS_AND_PRIVACY_POLICY')))])]), _vm._v(" "), _c('a', {
    staticClass: "help-line__fb",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "href": "https://www.facebook.com/Braster.eu/",
      "target": "_blank",
      "title": "Facebook"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('FACEBOOK')) + "\n                    ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca39021","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/footer/the-footer.vue
// module id = 1159
// module chunks = 0